module.exports = __webpack_public_path__ + "img/1574191976.eb531712.jpg";